export default "__VITE_ASSET__BVdPm1Ak__"